import useEntityCrud from '@/composable/useEntityCrud'
import useEntityHelper from '@/composable/useEntityHelper'
import i18n from '@/libs/i18n'
import useErrorManager from '@/composable/useErrorManager'

export default function useNotificationsList() {
  const MODULE_NAME = 'notifications'
  const ENDPOINT = 'notifications'
  const errorManager = useErrorManager()

  const { getAlt } = useEntityHelper()

  // Table Handlers
  const tableColumns = [
    {
      key: 'title', label: i18n.t('general.title'), type: 'textImage', textKey: 'title', imageKey: 'notificationImage', linkKey: 'notificationLink', sortable: true,
    },
    { key: 'type', label: i18n.t('general.type') },
    { key: 'isActive', label: i18n.t('notifications.isActive') },
    { key: 'link', label: i18n.t('notifications.link') },
    { key: 'updatedAt', label: i18n.t('general.updatedAt'), type: 'dateTime' },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  const typeOptions = [
    {
      title: i18n.t('notifications.topHeader'),
      _id: 'topHeader',
    },
    {
      title: i18n.t('notifications.popup'),
      _id: 'popup',
    },
  ]
  function convertResource(resource, selectedLang) {
    const type = typeOptions.find(typeEntry => resource.type === typeEntry._id)
    return {
      ...resource,
      title: resource.title[selectedLang],
      linkTitle: resource.linkTitle[selectedLang],
      description: resource.description[selectedLang],
      type: { title: type ? type.title : '', _id: type._id },
      notificationImage: resource.notificationImageFileId ? resource.notificationImageFileId[selectedLang] : '',
      notificationImageAlt: getAlt('notificationImageFaFileId', resource, selectedLang),
      lang: selectedLang,
      notificationLink: { name: 'pages-notifications-edit', params: { id: resource._id, lang: selectedLang } },
    }
  }
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)

  return {
    ...entity,
    convertResource,
    errorManager,
    tableColumns,
    typeOptions,
  }
}
